import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import Modal from 'components/Components/UI/Modal';
import GetQuoteForm from 'components/Components/Forms/GetQuoteForm/Loadable';
import HeaderFormQuote from "components/Components/Includes/HeaderFormQuote";
import { CONSTANTS } from 'services/constants';
import GetQuoteHubspotForm from 'components/Components/Forms/GetQuoteHubspotForm';
const { HOTEL_IDS } = CONSTANTS.DATA.BUSINESS_LOGIC.HUBSPOT_FORM;

class ModalQuote extends Component
{
    constructor(props)
    {
        super(props);
    }


    render()
    {
        const {
            image, title, subtitle, description, rooms, type, id, goingTo, titleType, headerPhoneNumber, logo, logoUrl
        } = this.props;

        const isHotelAvailableToShowHubspotForm = type === 'hotel' && HOTEL_IDS.includes(id);

        return (
            <Modal
                isOpen
                modalTitle=""
            >
                <Link className="modal-close-btn tw-text-gray-700 hover:tw-text-orange-400" to="#" onClick={this.props.onModalClose}>
                    <span className="tw-uppercase font-sp">Close</span>
                    <span className="material-icons tw-align-middle tw-ml-2">close</span>
                </Link>
                <HeaderFormQuote
                    logo={logo}
                    url={logoUrl}
                    onClose={this.props.onModalClose}
                    phoneNumber={headerPhoneNumber}
                    altLogo={title + ' logo'}
                />
                {isHotelAvailableToShowHubspotForm ? (
                    <GetQuoteHubspotForm />
                ) : (
                    <GetQuoteForm
                        image={image}
                        title={title}
                        titleType={titleType}
                        goingTo={goingTo}
                        description={description}
                        subtitle={subtitle}
                        type={type}
                        id={id}
                        rooms={rooms}
                        onCloseModal={this.props.onModalClose}
                    />
                )}
            </Modal>
        );
    }
}

ModalQuote.propTypes = {
    image: PropTypes.node.isRequired,
    title: PropTypes.node.isRequired,
    titleType: PropTypes.string,
    goingTo: PropTypes.string,
    subtitle: PropTypes.string,
    description: PropTypes.string,
    id: PropTypes.number,
    rooms: PropTypes.number,
    type: PropTypes.string,
    onModalClose: PropTypes.func,
    headerPhoneNumber: PropTypes.string,
    logo: PropTypes.string,
    logoUrl: PropTypes.string,
};

export default ModalQuote;
